module.exports = __webpack_public_path__ + "img/Lightning_Builder_Logo.22de990f.svg";